import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import UsersCard from "./UsersCard";
import { getUsersList, deleteUserListDetails } from "../Actions/UserManageAPI";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import ShipUsersCard from "./ShipUsersCard";
import { getStaffList, putStaffDetails } from "../Actions/StaffManagementAPI";
import { confirmAlert } from "react-confirm-alert";
import "./UserManagementMaster.css";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

let shipdata = {
  Name: '',
  PageNumber: 1,
  PageSize: 25
};
class ShipUserManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        Name: '',
        PageNumber: 1,
        PageSize: 25
      }
    }
    this.SearchUserList = this.SearchUserList.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getStaffList(this.state.searchData));
  }

  SearchUserList(pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = pgno;
    dispatch(getStaffList(this.state.searchData));
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    this.setState({});
  }

  ClearInput() {
    const { dispatch } = this.props;
    let param = { ...shipdata };
    this.setState({ searchData: param });
    dispatch(getStaffList(param));
  }

  eyeclick(item) {
    const { dispatch, history } = this.props;
    dispatch({ type: "ShowSidePan", data: false });
    dispatch({ type: "StaffDetails", data: item });
    history.push(`/Home/Management/EdiShipUser/${item.shipStaffId}`);
  }

  deleteUserList(item) {
    const{t}=this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label:  `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const { pagesearch } = this.props;
            let staffinfo = {
              shipStaffId: item.shipStaffId,
              name: item.name,
              phone: item.phone,
              email: item.email,
              address: item.address,
              isDeleted: true,
              modifiedBy: currentuser.name,
              modifiedDate: ""
            }
            this.props.dispatch(putStaffDetails(staffinfo));
            this.props.dispatch({ type: "ShowSidePan", data: false });
            this.props.history.goBack();
          }
        },
        {
          label:  `${t("confirmAlertMessage.No")}`,
          onClick: () => { }
        }
      ]
    });
  }

  render() {
    const { showSidePane, StaffInfoList,t } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className={this.state.showSidePane ? "col-lg-6" : "col-lg-12"}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                      <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                        <h5 className="card-title ml-2 mt-2 f2" style={{ color: "092a51" }}>{t("ShipUserManagementScreenContent.ShipUsers")}</h5>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row pb-2">
                        <div className="col-lg-6 m-auto">
                          <label className="form-label" >{t("MMPLUserManagementContent.EmailId")}</label><br></br>
                          <input className="form-control" type="text" name="Name" value={this.state.searchData.Name} placeholder="Email Id" onChange={e => this.handleInputChange(e)}></input>
                        </div>
                        <div className="col-lg-6 m-auto">
                          <label className="mt-4"></label><br></br>
                          <div className="search-btn-col" style={{ textAlign: "end" }}>
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit" onClick={() => this.SearchUserList(1)}>
                              {" "} {t("content.Search")}{" "}
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button" onClick={() => this.ClearInput()}>
                              {" "} {t("content.Clear")}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {StaffInfoList ?
                <ShipUsersCard
                  arraylist={StaffInfoList.data}
                  pageSize={StaffInfoList.pagination.pageSize}
                  totalRecords={StaffInfoList.pagination.totalcount ? StaffInfoList.pagination.totalcount : 0}
                  setUpdatedState={(value) => this.SearchUserList(value)}
                  eyeclick={(item) => this.eyeclick(item)}
                  deleteUserList={(item) => this.deleteUserList(item)}
                />
                : null}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan,
    StaffInfoList: state.SidePanReducer.StaffList
  }
}
export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(ShipUserManagement)));